import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { FooterGlobalStyle } from '../GlobalStyles';
import NotificationGlobalStyle from './notification/NotificationGlobalStyle';
import themeTokens from './themeTokens';

export const DEFAULT_THEME_CLASSNAME = 'theme-default';

const GlobalThemeToken = createGlobalStyle`
    html.${DEFAULT_THEME_CLASSNAME} {
        /* font sizes */
        --button-font-size: ${themeTokens.buttonFontSize};
        --input-font-size: ${themeTokens.inputFontSize};

        /* input field */
        --input-height: ${themeTokens.inputFieldHeight};
        
        /* checkboxes */
        --checkbox-width: 1.5rem;
        --checkbox-height: 1.5rem;

        --checkbox-summary-checked-inner-border-color: var(--ant-primary-color);
        --checkbox-checked-inner-border-color: #fff;
        --checkbox-summary-checked-inner-background-color: var(--ant-primary-color);
        --checkbox-checked-inner-background-color: #fff;
        
        /* For configurator pages */
        --configurator-text-color: var(--ant-primary-color);
        --configurator-border-radius: 0;
        --configurator-divider-color: rgba(255,255,255,0.5);
        --configurator-calculator-pre-summary-border-color: rgba(255,255,255,0.5);
        --configurator-calculator-summary-border-color: rgba(0,0,0,0.5);

        --configurator-back-color: #fff;
        --configurator-back-color-hover: #fff;
        --configurator-back-color-active: #fff;

        --configurator-widget-active-color: #fff;
        --configurator-widget-title-font-weight: 400;
        --configurator-widget-background: var(--ant-primary-color);
        --configurator-widget-text-color: #fff;

        --configurator-widget-popup-background: var(--ant-primary-color);
        --configurator-widget-popup-summary-text-color: var(--ant-primary-color);
        --configurator-widget-popup-text-color: #fff;
        --configurator-widget-popup-disabled-text-color: #fff;
        --configurator-widget-popup-text-color-opacity: 0.8;
        --configurator-widget-popup-calculator-background: #fff;

        --configurator-widget-bar-color: #ffffff7f;
        --configurator-widget-bar-open-color: #ffffff7f;

        --configurator-widget-checked-color: var(--ant-primary-color);

        --configurator-vehicle-select-height: 65px;
        --configurator-vehicle-select-label-padding-bottom: 8px;
        --configurator-widget-popup-calculator-field-background-color: rgba(0, 0, 0, 0.07);

        --configurator-widget-dealer-select-container-height: auto;
        --configurator-widget-dealer-select-container-form-item-display: flex;

        /* For calculator ui */
        --calculator-form-item-error-border: 1px var(--ant-error-color) solid;
        
        --calculator-field-background-color: rgba(0, 0, 0, 0.07);
        --calculator-field-label-padding: 0 11px;
        --calculator-field-label-color: rgba(0, 0, 0, 0.85);
        --calculator-field-disabled-label-color: rgba(0 ,0 ,0);
        --calculator-field-padding: 10px 5px;
        --calculator-grid-item-gap: 10px;
        --calculator-grid-item-min-height: min-content;

        --calculator-comparison-form-item-height-default: 57px;
        --calculator-comparison-form-item-height-second: 57px;
        --calculator-comparison-below-condition-background: #f5f5f5;
        --calculator-comparison-form-item-ant-typography-padding-left-right: 11px;
        --calculator-comparison-mobile-form-item-padding-top: 45px;
        --calculator-comparison-mobile-form-item-padding-top-sm: 35px;
        --calculator-comparison-form-item-error-position: absolute;
        --calculator-comparison-vehicle-image-height: 337px;
        --calculator-comparison-vehicle-image-height-xl: 179px;
        --calculator-comparison-vehicle-image-height-lg: 121px;
        --calculator-comparison-vehicle-image-height-m: 180px;
        --calculator-comparison-vehicle-image-height-sm: 225px;

        --vehicle-image-border-radius: 0px;

        --image-selection-border: 1px solid transparent;
        --image-selection-border-radius: 0px;
        --image-selection-active-border-color: var(--ant-primary-color);
        --image-selection-outline: 0px;
        --image-selection-outline-offset: 0px;
        --image-selection-active-outline-color: transparent;

        --carousel-images-dots-bottom: 12px;
        --carousel-images-dots-gap: 0px;
        --carousel-images-dots-width: 16px;
        --carousel-images-dots-height: 3px;
        --carousel-images-dots-background-color: #767676;
        --carousel-images-dots-border-radius: 1px;
        --carousel-images-dots-opacity: 0.3;
        --carousel-images-dots-box-shadow: none;
        --carousel-images-dots-active-width: 24px;
        --carousel-images-dots-active-height: 3px;
        --carousel-images-dots-active-background-color: var(--ant-primary-color);
        --carousel-images-dots-active-opacity: 1;
        --carousel-images-dots-active-box-shadow: none;
    }
`;

const DefaultGlobalStyles = () => {
    useEffect(() => {
        document.documentElement.classList.add(DEFAULT_THEME_CLASSNAME);

        return () => {
            document.documentElement.classList.remove(DEFAULT_THEME_CLASSNAME);
        };
    }, []);

    return (
        <>
            <GlobalThemeToken />
            <NotificationGlobalStyle />
            <FooterGlobalStyle />
        </>
    );
};

export default DefaultGlobalStyles;
